import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { ContentCategoriesAdminParams, ContentCategoryAdminResponse } from './types';

export async function getContentCategoriesAdmin(params: ContentCategoriesAdminParams = {}) {
  const url = '/web/studio/content-categories';

  const queryParams: Record<string, string | number | boolean> = {};

  if (params.search) queryParams.search = params.search;
  if (params.includeDestroyed) queryParams.include_destroyed = true;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;

  const response = await api.executeGetRequest<PaginatedListResponse<ContentCategoryAdminResponse>>(url, queryParams);

  return response;
}
